import {
    configureStore,
    combineReducers,
    getDefaultMiddleware
} from '@reduxjs/toolkit';

import restaurantSearchReducer from './slices/restaurantSearchSlice';
import previewSliceReducer from "./slices/previewSlice";
import webpSupportSliceReducer from "./slices/webpSupportSlice";

const combinedReducer = combineReducers({
    restaurantSearch: restaurantSearchReducer,
    preview: previewSliceReducer,
    webpSupport: webpSupportSliceReducer
});

const rootReducer = (state, action) => {
    return combinedReducer(state, action);
};

export default configureStore({
    reducer: rootReducer,
    middleware: [...getDefaultMiddleware()],
});
